// useInitSidebarLinks.ts

import {useEffect} from 'react';

import {useSidebarApi} from 'mfe/host/app-sidebar';

import {Icons} from '@pb/kit-component-icon';


export const useInitSidebarLinks = () => {
    const {initialize, destroy} = useSidebarApi();

    useEffect(() => {
        initialize({items: [
            {
                title: 'CCDB Database',
                icon: Icons.SEARCH,
                children: [
                    {path: '/ccdb/company-search', title: 'Search Company', icon: Icons.SEARCH},
                    {path: '/ccdb/company-management', title: 'Company Management', icon: Icons.EDIT},
                    {path: '/ccdb/rna-mapping', title: 'RNA Mapping', icon: Icons.LIST},
                    {path: '/ccdb/company-list', title: 'Company List', icon: Icons.TASKS},
                    {path: '/ccdb/holiday', title: 'Holiday', icon: Icons.CALENDAR},
                    {path: '/ccdb/push-companies', title: 'Push Companies', icon: Icons.ARROW_UP_RIGHT},
                    {path: '/manage-event-calendar', title: 'Manage Event Calendar', icon: Icons.CALENDAR},
                ],
                onCollapsedStateShowInnerItems: true,
                opened: true,
            },
        ]});
        return () => destroy();
    }, [initialize, destroy]);
};
